import { createContext, useContext } from 'react';
import { IDesignDialogActions } from './IDesignDialogActions';


// Create the context. We start with `undefined` and will provide the real value later.
export const DesignDialogActionsContext = createContext<IDesignDialogActions | undefined>(undefined);

// Create a custom consumer hook for clean and safe access to the context.
export const useDesignDialogActionsContext = () => {
    const context = useContext(DesignDialogActionsContext);
    if (context === undefined) {
        // This error prevents the context from being used outside of its provider.
        throw new Error('useDesignDialogActionsContext must be used within a DesignDialogActionsProvider');
    }
    return context;
};